module.exports = __webpack_public_path__ + "img/old-man.31dfe677.png";